import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description: 'A yes, no, or N/A response for a change impact',
    name: 'Change Impact Yes No N/A',
    partialId: PartialId.Standard.create('change_impact_yes_no_na'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
